import Blue from "~/core";

new Blue({
    name: "AviationBlogPage",
    selector: ".aviation-blog-page",
    setup(aviationBlogPage) {
        const sliderArticles = Array.from(aviationBlogPage.querySelectorAll('.aviation-blog-sidebar-slider .aviation-blog-related-article'));

        const nextButton = aviationBlogPage.querySelector('.aviation-blog-sidebar-slider-control.is-next');
        const prevButton = aviationBlogPage.querySelector('.aviation-blog-sidebar-slider-control.is-prev');

        let currentIndex = 0;

        // Function to remove "is-active" from all slides
        const updateActiveSlide = (index) => {
            sliderArticles.forEach((article, i) => {
                article.classList.toggle('is-active', i === index);
            });
        };

        // if there is only 1 slide then hide the next and previous buttons
        if (sliderArticles.length === 1) {
            nextButton.style.display = 'none';
            prevButton.style.display = 'none';
        }
        else {
            // Event listener for Next button
            nextButton.addEventListener('click', (e) => {
                e.preventDefault();
                currentIndex = (currentIndex + 1) % sliderArticles.length; // Increment index and loop back if at the end
                updateActiveSlide(currentIndex);
            });

            // Event listener for Previous button
            prevButton.addEventListener('click', (e) => {
                e.preventDefault();
                currentIndex = (currentIndex - 1 + sliderArticles.length) % sliderArticles.length; // Decrement index and loop to end if at the beginning
                updateActiveSlide(currentIndex);
            });
        }
        
        // Initial call to set the first slide as active
        updateActiveSlide(currentIndex);

    },
});
